import React, { useEffect, useState } from 'react';
import { useExportDrivers } from '../../hooks/react-query/useDrivers';
import { CustomModal } from '../ui';
import { FileArrowDown, PlusIcon, SpinnerIcon } from '../../icons';
import AddEditDriver from './addEditDriver';
import { useLocation, useNavigate } from 'react-router-dom';
import { useModalStore } from '../../store/modalStore';

const ToolBar = ({
  handleAddMultipleDrivers,
  showAddDriver = true,
  showMobileView = true,
  showExport = true,
}) => {
  const { mutate: getExistingDrivers, isLoading } = useExportDrivers();
  const [openModal, setOpenModal] = useState(false);

  const {modalToOpen, setModalToOpen} = useModalStore()


  const handleExportDrivers = () => {
    getExistingDrivers();
  };

  useEffect(()=>{
    if(modalToOpen[0] === 'add'){
      setOpenModal(true);
      setModalToOpen('')
    }
  },[modalToOpen])

  return (
    <>
      {!!showExport && (
        <button
          type="button"
          className={`lg:btn-primary lg:bg-primary lg:text-white lg:px-10 lg:py-3 lg:rounded-full flex items-center flex-col gap-x-2 ${
            !showMobileView && 'max-lg:hidden'
          } `}
          onClick={handleExportDrivers}
        >
          <div className="max-lg:hidden">
            {isLoading ? (
              <div className="flex items-center gap-2">
                <SpinnerIcon className="w-4 h-4 fill-white" />{' '}
                <span>Εξαγωγή αρχείου</span>
              </div>
            ) : (
              <>Εξαγωγή αρχείου</>
            )}
          </div>
          <div className="lg:hidden">
            <FileArrowDown className="stroke-white stroke-1 bg-primary rounded-full p-1 h-8 w-8" />
          </div>
        </button>
      )}
      {showAddDriver && (
        <CustomModal
          triggerComponent={
            <div className="max-lg:hidden flex items-center gap-3">
              <span className="text-primary-button">Καταχώριση νέου οδηγού</span>
              <PlusIcon />
            </div>
          }
          wrapperClass="max-lg:h-full"
          handleClick={(value) => setOpenModal(value)}
          openModal={openModal}
        >
          <AddEditDriver
            setOpenModal={setOpenModal}
            handleAddMultipleDrivers={handleAddMultipleDrivers}
          />
        </CustomModal>
      )}
    </>
  );
};

export default ToolBar;
